// extracted by mini-css-extract-plugin
export var dropdownButton = "_3v-0";
export var fullWidthDropdownButton = "_3v-1";
export var icon = "_3v-3";
export var iconPlaceholder = "_3v-2";
export var menuItemRow = "_3v-8";
export var separator = "_3v-c";
export var shortcutContainer = "_3v-7";
export var shortcutIconLg = "_3v-6";
export var shortcutIconMd = "_3v-5";
export var shortcutIconSm = "_3v-4";
export var submenuChevron = "_3v-b";
export var submenuDropdown = "_3v-9";
export var submenuTriggerRow = "_3v-a";